import React, { useEffect, useState } from 'react';

interface SessionWarningModalProps {
  expiryEpochSec: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  expiryEpochSec,
  onStayLoggedIn,
  onLogout,
}) => {
  const [secondsRemaining, setSecondsRemaining] = useState<number>(() => {
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, expiryEpochSec - now);
  });

  useEffect(() => {
    const interval = window.setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      setSecondsRemaining(Math.max(0, expiryEpochSec - now));
    }, 1000);
    return () => window.clearInterval(interval);
  }, [expiryEpochSec]);

  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;

  return (
    <div className="modal-overlay">
      <div className="modal session-warning-modal">
        <h3>Session expiring soon</h3>
        <p>
          Your session will expire in {minutes}:{seconds.toString().padStart(2, '0')}
          <br />
          Do you want to stay logged in?
        </p>
        <div className="modal-actions">
          <button onClick={onLogout} className="cancel-button">Logout</button>
          <button onClick={onStayLoggedIn} className="refresh-button">Stay Logged In</button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningModal;


